
import { usePomodoro } from '../../hooks/usePomodoro';
import PomodoroTimer from './components/PomodoroTimer';
import TaskBoard from './components/TaskBoard';

export default function Home() {
  const {
    tasks,
    activeTask,
    activeTaskId,
    timerMode,
    timeLeft,
    isRunning,
    filter,
    totalPomodoros,
    addTask,
    deleteTask,
    toggleTaskComplete,
    setActiveTask,
    startTimer,
    pauseTimer,
    resetTimer,
    formatTime,
    setFilter,
  } = usePomodoro();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-green-50">
      {/* Header */}
      <header className="bg-white/80 backdrop-blur-sm border-b border-slate-200/50 px-4 py-3">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-green-500 rounded-lg flex items-center justify-center">
              <i className="ri-timer-2-line text-white text-lg"></i>
            </div>
            <h1 className="text-xl font-semibold text-slate-800">Pomodoro Tasker</h1>
          </div>
          <div className="flex items-center gap-4">
            <div className="text-sm text-slate-600">
              <span className="font-medium">{totalPomodoros}</span> pomodoros completed
            </div>
            <button className="w-8 h-8 flex items-center justify-center rounded-lg bg-slate-100 hover:bg-slate-200 transition-colors">
              <i className="ri-settings-3-line text-slate-600"></i>
            </button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 py-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 min-h-[calc(100vh-100px)]">
          {/* Left Column: Pomodoro Timer */}
          <div className="flex flex-col justify-center">
            <PomodoroTimer
              timeLeft={timeLeft}
              timerMode={timerMode}
              isRunning={isRunning}
              activeTask={activeTask}
              formatTime={formatTime}
              onStart={startTimer}
              onPause={pauseTimer}
              onReset={resetTimer}
              totalPomodoros={totalPomodoros}
            />
          </div>

          {/* Right Column: Task Management Board */}
          <div className="flex flex-col h-full">
            <TaskBoard
              tasks={tasks}
              activeTaskId={activeTaskId}
              onAddTask={addTask}
              onDeleteTask={deleteTask}
              onToggleComplete={toggleTaskComplete}
              onSetActiveTask={setActiveTask}
            />
          </div>
        </div>
      </main>
    </div>
  );
}
